var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.315,
    height: 15.315,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12040",
    fill: "#2d3e5c",
    stroke: "#707070",
    d: "M0 0h15.315v15.315H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 342",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12041",
    fill: "none",
    d: "M0 0h15.315v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15951",
    d: "M11.806 9.333a2.453 2.453 0 0 0-2.01 1.033L5.393 8.4a1.7 1.7 0 0 0 .031-.4 1.7 1.7 0 0 0-.032-.4l4.4-1.967a2.453 2.453 0 0 0 2.01 1.033A2.611 2.611 0 0 0 14.358 4a2.555 2.555 0 1 0-5.105 0 1.7 1.7 0 0 0 .032.4L4.886 6.367a2.453 2.453 0 0 0-2.01-1.033A2.611 2.611 0 0 0 .319 8a2.611 2.611 0 0 0 2.553 2.667 2.453 2.453 0 0 0 2.014-1.034l4.4 1.967a1.7 1.7 0 0 0-.032.4 2.555 2.555 0 1 0 2.552-2.667Zm0-6.667A1.306 1.306 0 0 1 13.086 4a1.277 1.277 0 1 1-2.553 0 1.306 1.306 0 0 1 1.273-1.333ZM2.872 9.333a1.335 1.335 0 0 1 0-2.667 1.335 1.335 0 0 1 0 2.667Zm8.934 4A1.335 1.335 0 1 1 13.086 12a1.306 1.306 0 0 1-1.28 1.333Z",
    fill: "#2d3e5c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbShare);
export default __webpack_public_path__ + "static/media/fb_share.a3d9dcdd29d4802c0686fa721aaf9f2d.svg";
export { ForwardRef as ReactComponent };